import React from "react";
import { observer, inject } from "mobx-react";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			marginTop: "-60px",
			paddingTop: "60px",
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				marginTop: "-40px",
				paddingTop: "40px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				marginTop: "-20px",
				paddingTop: "20px",
			},
		},
	};
};

@inject("ApplicationModel")
@observer
class WithFiltersWidget extends React.Component {
	constructor(props) {
		super(props);
		let model = props.ApplicationModel.fixedPanelModel;
		model.showFiltersWidget();
	}

	componentDidMount() {
		let model = this.props.ApplicationModel.fixedPanelModel;
		model.setFiltersWidgetContent(this.root);
	}

	componentWillUnmount() {
		let model = this.props.ApplicationModel.fixedPanelModel;
		model.hideFiltersWidget();
	}

	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classes.root}
				ref={(root) => {
					this.root = root;
				}}
			>
				{this.props.children}
			</div>
		);
	}
}

export default withStyles(styles)(WithFiltersWidget);
